<template>
  <div id="Register">
    <div class="register_box">
      <Title title_name="會員註冊填寫"></Title>
      <div class="register_content">
        <form>
          <InputBox v-for="(item, index) in input_info.slice(3, 5)" :key="item.input_id" :input_info="input_info.slice(3, 5)[index]" :flag="flag" @input_content="input_content"></InputBox>
          <!-- 信箱驗證 -->
          <div class="email_message">
            <a href="javascript:void(0);" @click="get_email" :class="{'email_no_click' : email_sec !=0 }">取得驗證碼</a>&nbsp;
            <span v-if="email_sec!=0">下次發送{{email_sec}}秒</span>
          </div>
          <InputBox v-for="(item, index) in input_info.slice(5, 11)" :key="item.input_id" :input_info="input_info.slice(5, 11)[index]" :pwd_check="pwd_check" :flag="flag" @input_content="input_content"></InputBox>
          <!-- 手機驗證 -->
          <div class="sms_message">
            <a href="javascript:void(0);" @click="get_sms" :class="{'sms_no_click' : phone_sec !=0 }">取得驗證碼</a>&nbsp;
            <span v-if="phone_sec!=0">下次發送{{phone_sec}}秒</span>
          </div>
          <!-- 居住區域 -->
          <div >
            <label class="residential_area_title">居住區域 (必填)</label>
            <div>
              <div v-for="(option, index) in input_info[16].input_options.split(',')" :key="index">
                <label>
                  <input type="radio" :name="input_info[16].input_name" :value="index + 1" v-model="member_info.residential_area" @change="input_content"/> {{ option.trim() }}
                </label>
              </div>
            </div>
          </div>
          <!-- 居住地址 -->
          <div class="inputbox_container">
            <label for="">居住地址 (非必填)</label>
            <section class="mb-2 d-flex">
              <input id="address" type="text" disabled=disabled :placeholder="zipid" :class="{'no_input' : zipid == 0}">
              <select class="selectbox" name="county_select" v-model="county_select" :class="{'no_input' : county_select == 0}">
                <option value="0" disabled selected>請選擇縣市</option>
                <option v-for="item in zip" :key="item.id" :value="item.id" >{{item.county}}</option>
              </select>
              <select class="selectbox" name="city_select" v-model="city_select" :class="{'no_input' : city_select == -1}">
                <option value="-1" disabled selected>請選擇行政區</option>
                <option v-for="item in city" :key="item.id" :value="item.id">{{item.city}}</option>
              </select>
            </section>
            <input id="addressText" type="text" placeholder="請輸入詳細地址" v-model="address_data" :class="{'no_input' : address_data == ''}" name="address">
          </div>
          <!-- 活動清單 -->
          <div v-if="checkboxList.length > 0" class="ticket_sign_list">
            <label class="ticket_sign_list_title">近期熱門展覽立即索票</label>
            <div style="padding:0 10px;">
              <div v-for="item in checkboxList" :key="item.id" style="padding:5px 0;">
                <input
                  type="checkbox" 
                  :id="item.ticket_id" 
                  :value="item.ticket_id" 
                  v-model="checkedTickets" 
                />
                <label :for="item.ticket_id">{{ item.name }}</label>
              
                <div v-if="filteredInputFields(item.ticket_id).length > 0" class="pop_inputField">
                  <div v-for="fieldGroup in filteredInputFields(item.ticket_id)" :key="fieldGroup.id">
                    <div v-for="field in fieldGroup.custom_field" :key="field.field_name" style="font-size:0.8rem;display: flex; padding:0.3rem">
                      <label :for="field.field_name" style="width:40%">{{ field.field_label }}</label>
                      <div v-if="field.field_type === 'text' || field.field_type === 'date' || field.field_type === 'address' || field.field_type === 'textarea'" style="width:60%;margin-left:30px">
                        <input 
                          :type="field.field_type" 
                          :id="field.field_name" 
                          :name="field.field_name" 
                          v-model="formValues[item.ticket_id][field.field_name]" 
                          :required="field.field_rule === 'required'"
                          style="width: 100%;"
                        />
                      </div>
                      <div v-if="field.field_type === 'checkbox'" style="width:60%;margin-left:30px">
                        <label v-for="option in field.field_options.split(',')" :key="option">
                          <input 
                            type="checkbox" 
                            :name="`${field.field_name}`" 
                            :value="option"
                            v-model="checkboxStates[item.ticket_id][field.field_name][option]" 
                          /> {{ option }}
                        </label>
                      </div>
                      <div v-if="field.field_type === 'radio'" style="width:60%;margin-left:30px">
                        <label v-for="option in field.field_options.split(',')" :key="option">
                          <input 
                            type="radio" 
                            :name="`${field.field_name}`" 
                            :value="option"
                            v-model="radioStates[item.ticket_id][field.field_name]" 
                          /> {{ option }}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="agree_box">
            <input type="checkbox" v-model="agree">
              <span> 同意 <router-link to="/register/contract" target="_blank">會員服務使用條款</router-link></span>
          </div>
        </form>
      </div>
      <div>
        <MoreButton button_text="註冊會員" button_href="javascript:void(0);" @click.native="submit_register" :loading="loading"></MoreButton>
      </div>
    </div>
  </div>
</template>
<script>
import Title from '@/components/base/Title'
import InputBox from '@/components/base/InputBox'
import MoreButton from '@/components/base/MoreButton'
import zipcode from '@/plugins/zipcode'
export default {
  name: 'register',
  components: {
    Title: Title,
    InputBox: InputBox,
    MoreButton: MoreButton
  },
  data() {
    return {
      input_info: require("@/plugins/input_info"), // input資料
      register_data: new FormData(), // 最後送出的資料
      member_info: {
        email: '',
        password: '',
        password_check: '',
        name: '',
        phone_number:'',
        verify_code: '',
        email_verify_code: '',
        cid: '',
        residential_area: '',
      },
      flag: {}, // 檢查表單是否正確填寫 True False
      submit_flag: false,
      pwd_check: true, //檢查再次輸入密碼
      agree: false, // checkbox
      email_sec: 0, // 信箱重發秒數
      phone_sec: 0, // 簡訊重發秒數
      loading: false,
      login_token: null,
      checkboxList: [],
      inputFields: [],
      checkedTickets: [],
      formValues: {},
      checkboxStates: {},
      radioStates: {},

      // 地址參數設定
      address_error: '',
      zip: zipcode,
      city: '',
      county_select: 0,
      city_select: -1,
      city_check: true,
      zipid: 0,
      county_data: '', // 選擇的縣市
      city_data: '',    // 選擇的行政區
      zip_data: '',    // 選擇的郵遞區號
      road: '',        // 如果有值會直接取出
      address_data: '', // 輸入的地址
    }
  },
  watch: {
    // 驗證密碼是否一樣
    'member_info.password_check': function (v) {
      (v == this.member_info.password) ? this.pwd_check = true : this.pwd_check = false
    },
    'member_info.password': function (v) {
      (v == this.member_info.password_check) ? this.pwd_check = true : this.pwd_check = false
    },
    county_select(id){
      var vm = this
      vm.city = vm.zip[id-1].city
      if(vm.city_check){
        vm.city_select = -1
        vm.city_data = ''
        vm.zipid = 0
        vm.zip_data = ''
        vm.road = ''
      }
      vm.county_data = vm.zip[id-1].county
      vm.city_check=true 
    },
    city_select(id){
      var vm = this
      if(vm.city_select != -1){
        vm.zipid = vm.city[id].zip
        vm.city_data = vm.city[id].city
        vm.zip_data = vm.city[id].zip
      } else {
        vm.address_data = vm.member_new.road = ""
      }
    },
    address_data(v){
      this.member_new.road = v
    }
  },
  computed: {
    API() {
      return process.env.NODE_ENV === "production" ? "https://www.top-link.com.tw/" : "https://apitest.top-link.com.tw/";
    },
  },
  created() {
    this.fetchTicketData();
  },
  methods: {
    input_content(v){
      if (!(v instanceof Event)) {
        this.member_info[v[1]] = v[0];
        this.register_data.set(v[1], v[0])
      }
      this.validForm()
    },
    get_email(){
      var vm = this
      var email_api = vm.API + "api/email/get_verify_code"
      // var email_api = vm.API + "email/get_verify_code"  // 測試用
      var verity_data = new FormData()
      verity_data.append("email", vm.member_info.email)

      if(vm.member_info.email==""){
        alert("信箱不可為空")
      } else{
          vm.axios.post(email_api, verity_data).then(res => {
          if(res.data.status == 200){
            vm.email_sec = parseInt(res.data.data.expired_sec)
            alert(res.data.message)
            // 簡訊發送後開始倒數
            var interval = setInterval(() => {
              if(vm.email_sec==0){ clearInterval(interval) }
              else { vm.email_sec-- }
            }, 1000);
          } else{
            alert("錯誤碼: " + " " + res.data.status + res.data.message)
          }
        })
      }
    },
    get_sms(){
      var vm = this
      var sms_api = vm.API + "api/sms/get_verify_code"
      // var sms_api = vm.API + "sms/get_verify_code" //測試用
      var verity_data = new FormData()
      verity_data.append("phone_number", vm.member_info.phone_number)
      if(vm.member_info.phone_number==""){
        alert("手機號碼不可為空")
      } else{
          vm.axios.post(sms_api, verity_data).then(res => {
          if(res.data.status == 200){
            vm.phone_sec = parseInt(res.data.data.expired_sec)
            alert(res.data.message)
            // 簡訊發送後開始倒數
            var interval = setInterval(() => {
              if(vm.phone_sec==0){ clearInterval(interval) }
              else { vm.phone_sec-- }
            }, 1000);
          } else{
            alert("錯誤碼: " + " " + res.data.status + res.data.message)
          }
        })
      }
    },
    submit_register() {
      var vm = this;
      var register_api = vm.API + "api/member/register"
      var ticket_sign_api = vm.API + "api/ticket/sign"
      // 測試用
      // var register_api = vm.API + "member/register"
      // var ticket_sign_api = vm.API + "ticket/sign"

      // 檢查表單是否正確
      let rowName = '';
      if (!vm.submit_flag) {
        // 檢查所有欄位是否有值
        for (var key in vm.member_info) {
          if (!vm.member_info[key] && vm.member_info.key != 'address') {
            switch (key) {
              case 'email':
                rowName = '『E-mail』';
                break;
              case 'phone_number':
                rowName = '『手機號碼』';
                break;
              case 'password':
                rowName = '『密碼』';
                break;
              case 'password_check':
                rowName = '『密碼確認』';
                break;
              case 'cid':
                rowName = '『身分證後六碼』';
                break;
              case 'name':
                rowName = '『姓名』';
                break;
              case 'verify_code':
                rowName = '『手機驗證碼』';
                break;
              case 'email_verify_code':
                rowName = '『信箱驗證碼』';
                break;
              case 'residential_area':
                rowName = '『居住區域』';
                break;
            }
            alert("請填寫" + rowName + "欄位");
            return;
          }
        }
        alert("表單輸入有誤，請重新檢查");
      } else if (!vm.pwd_check) {
        alert("密碼輸入不一致，請重新檢查");
      } else if (!vm.agree) {
        alert("請詳細閱讀使用條款後勾選同意");
      } else {
        for (let key in this.formValues) {
          if (Array.isArray(this.formValues[key])) {
            for (let i = 0; i < this.formValues[key].length; i++) {
              this.register_data.append(`ticket_sign_field[${key}][]`, this.formValues[key][i]);
            }
          } else {
            this.register_data.append(`ticket_sign_field[${key}]`, this.formValues[key]);
          }
        }

        // 檢查動態生成欄位
        for (var item of this.checkedTickets) {
          var inputFields = this.filteredInputFields(item);
          for (var fieldGroup of inputFields) {
            for (var field of fieldGroup.custom_field) {
              if (field.field_type === 'checkbox') {
                var selectedOptions = [];
                for (var option in this.checkboxStates[item][field.field_name]) {
                  if (this.checkboxStates[item][field.field_name][option]) {
                    selectedOptions.push(option);
                  }
                }
                if (field.field_rule === 'required' && selectedOptions.length === 0) {
                  alert(`請填寫${field.field_label}`);
                  return;
                }
                selectedOptions.forEach(option => {
                  this.register_data.append(`ticket_sign_field[${field.field_name}][]`, option);
                });
              } else if (field.field_type === 'radio') {
                var selectedRadioValue = ''
                for (var radioOption in this.radioStates[item][field.field_name]) {
                  if (this.radioStates[item][field.field_name][radioOption]) {
                    selectedRadioValue = radioOption;
                    break;
                  }
                }

                if (field.field_rule === 'required' && !selectedRadioValue) {
                  alert(`請選擇 ${field.field_label} 選項`);
                  return;
                }
                if (!this.register_data.has(`ticket_sign_field[${field.field_name}]`)) {
                  this.register_data.append(`ticket_sign_field[${field.field_name}]`, selectedRadioValue);
                }
              } else {
                var fieldValue = this.formValues[item][field.field_name];
                if (field.field_rule === 'required' && (fieldValue === undefined || fieldValue === null || fieldValue === '')) {
                  alert(`請填寫${field.field_label}`);
                  return;
                }
                this.register_data.append(`ticket_sign_field[${field.field_name}]`, fieldValue);
              }
            }
          }
        }
        
        // 送出表單
        vm.loading = true;
        vm.axios.post(register_api, vm.register_data).then(res => {
          if (res.data.status == 200) {
            if (res.data.message === 'ok') {
              this.login(vm.member_info.email, vm.member_info.password).then(() => {
                var ticket_sign_data = this.submitTicketSign()

                // 遍歷 ticket_sign_data 並發送 API 請求
                var promises = [];
                for (var ticketId in ticket_sign_data) {
                  let data = ticket_sign_data[ticketId]
                  let ticketSignFormData = new FormData()
                  ticketSignFormData.append('ticket_ids[]', ticketId)
                  ticketSignFormData.append('token', this.login_token)
                  ticketSignFormData.append('name', vm.member_info.name)
                  ticketSignFormData.append('cid', vm.member_info.cid)
                  if (vm.zip_data != '') {
                    ticketSignFormData.append('postal_code', vm.zip_data)
                  }
                  if (vm.county_data != '') {
                    ticketSignFormData.append('county', vm.county_data)
                  }
                  if (vm.city_data != '') {
                    ticketSignFormData.append('district', vm.city_data)
                  }
                  if (vm.address_data != '') {
                    ticketSignFormData.append('address', vm.address_data)
                  }
                  ticketSignFormData.append('residential_area', vm.member_info.residential_area)
                  for (var key in data) {
                    if (Array.isArray(data[key])) {
                      data[key].forEach(value => {
                        ticketSignFormData.append(`${key}`, value);
                      });
                    } else {
                      ticketSignFormData.append(key, data[key]);
                    }
                  }
                  promises.push(vm.axios.post(ticket_sign_api, ticketSignFormData));
                }

                Promise.all(promises).then(results => {
                  results.forEach(result => {
                    if (result.data.status !== 200) {
                      alert("錯誤碼: " + result.data.status + "  " + result.data.message);
                    }
                  });
                  // alert("所有票券資料已成功提交");
                  vm.loading = false
                  // 因為 push 帶 path 和 params ， params 會失效，故使用 name 代替 push
                  vm.$router.push({name: 'register_ok', params: {email: vm.member_info.email}})
                })
                .catch(error => {
                  console.log(error);
                  alert("提交票券資料時發生錯誤");
                  vm.loading = false;
                });
              })
            } else {
              alert("錯誤碼: " + res.data.status + "  " + res.data.message);
              vm.loading = false;
            }
          } else {
            var alr = "";
            switch (res.data.status) {
              case 600:
                alr = "請確認表單是否正確填寫";
                break;
              default:
                alr = res.data.message;
            }
            alert("錯誤碼: " + res.data.status + "  " + alr);
            vm.loading = false;
          }
        }).catch(function(error) {
          console.log(error);
        });
      }
    },
    validForm() {
      var vm = this
      var reg = new RegExp()
      let flag = null
      for(var index in vm.member_info){
        // 建立正規式
        switch(index){
          case 'email':
            // eslint-disable-next-line
            reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            break
          case 'phone_number':
            reg = /^09[0-9]{8}$/
            break
          case 'password':
            reg = /^\w{6,12}$/
            break
          case 'password_check':
            reg = /^\w{6,12}$/
            break
          case 'cid':
            reg = /^[0-9]{6}$/
            break
          case 'verify_code':
            reg = /^[0-9]{6}$/
            break
          case 'email_verify_code':
            reg = /^[0-9]{6}$/
            break
          default:
            reg = /./
        }
        flag = reg.test(vm.member_info[index])
        vm.$set(vm.flag, index, flag)
      }
      for(var temp in vm.flag){
        if(!vm.flag[temp]){
          vm.submit_flag = false
          return 0
        } else {
          vm.submit_flag = true
        }
      }

      vm.register_data.set('residential_area', vm.member_info.residential_area);
      vm.register_data.set('postal_code', vm.zip_data);
      vm.register_data.set('county', vm.county_data);
      vm.register_data.set('district', vm.city_data);
      vm.register_data.set('address', vm.address_data);

      // console.log(vm.flag)
      return true
    },
    fetchTicketData() {
      var vm = this
      var api = vm.API + "api/ticket/register_front_show_list"
      // var api = vm.API + "ticket/register_front_show_list" // 測試用
      this.axios.get(api).then(res => {
        if(res.data.status == 200) {
          if (res.data.data && res.data.data.checkboxList && res.data.data.checkboxList.length > 0) {
            vm.checkboxList = res.data.data.checkboxList;
            vm.inputFields = res.data.data.inputFields;
            vm.initializeCheckboxStates();
          }
        } else {
          alert("錯誤碼: " + " " + res.data.status + res.data.message)
        }
      });
    },
    filteredInputFields(ticket_id) {
      return this.checkedTickets.includes(ticket_id) 
        ? this.inputFields.filter(fieldGroup => fieldGroup.ticket_id === ticket_id) 
        : [];
    },
    login(email, password){
      var vm = this
      var login_api = vm.API + 'api/auth/login/web'
      // var login_api = vm.API + 'auth/login/web'  // 測試用
      var login_data = new FormData()
      login_data.set('email', email)
      login_data.set('password', password) 
      return vm.axios.post(login_api, login_data).then((res) => {
        if(res.data.status == 200){
          this.login_token = res.data.data.token
          vm.$cookies.config(60*60*12, '')
          vm.$cookies.set('member', JSON.stringify(res.data.data))
          // vm.loading = false
          // vm.$router.push("/member/profile")
        } else if(res.data.status == 711){
          vm.$router.push({name: 'email_auth', params: {email: vm.email}})
        } else {
          alert("錯誤碼: " + res.data.status + " " + res.data.message)
          vm.loading = false
        }
      })
      .catch(function(error) {
        console.log(error)
      })
    },
    initializeCheckboxStates() {
      this.inputFields.forEach(fieldGroup => {
        fieldGroup.custom_field.forEach(field => {
          if (field.field_type === 'checkbox') {
            if (!this.checkboxStates[fieldGroup.ticket_id]) {
              this.$set(this.checkboxStates, fieldGroup.ticket_id, {});
            }
            this.$set(this.checkboxStates[fieldGroup.ticket_id], field.field_name, {});
            field.field_options.split(',').forEach(option => {
              this.$set(this.checkboxStates[fieldGroup.ticket_id][field.field_name], option, false);
            });
          } else if (field.field_type === 'radio') {
            if (!this.radioStates[fieldGroup.ticket_id]) {
              this.$set(this.radioStates, fieldGroup.ticket_id, {});
            }
            this.$set(this.radioStates[fieldGroup.ticket_id], field.field_name, {});
            field.field_options.split(',').forEach(option => {
              this.$set(this.radioStates[fieldGroup.ticket_id][field.field_name], option, false);
            });
          } else if (!this.formValues[fieldGroup.ticket_id]) {
            this.$set(this.formValues, fieldGroup.ticket_id, {});
            this.$set(this.formValues[fieldGroup.ticket_id], field.field_name, '');
          }
        });
      });
    },
    submitTicketSign() {
      var vm = this;
      var ticket_sign_data = {};

      vm.checkedTickets.forEach(ticketId => {
        var fieldData = {};
        var inputFields = vm.filteredInputFields(ticketId);
        
        inputFields.forEach(fieldGroup => {
          fieldGroup.custom_field.forEach(field => {
            var fieldName = field.field_name;
            
            switch(field.field_type) {
              case 'checkbox':
                var selectedOptions = [];
                for (var option in vm.checkboxStates[ticketId][fieldName]) {
                  if (vm.checkboxStates[ticketId][fieldName][option]) {
                    selectedOptions.push(option);
                  }
                }
                if (selectedOptions.length > 0) {
                  fieldData[`${fieldName}`] = selectedOptions;
                }
                break;
              case 'radio':
                var selectedRadioValue = '';
                for (var radioOption in vm.radioStates[ticketId][fieldName]) {
                  if (vm.radioStates[ticketId][fieldName][radioOption]) {
                    selectedRadioValue = radioOption;
                    break;
                  }
                }
                if (selectedRadioValue !== '') {
                  fieldData[fieldName] = selectedRadioValue;
                }
                break;
              default:
                var fieldValue = vm.formValues[ticketId][fieldName];
                if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
                  fieldData[fieldName] = fieldValue;
                }
                break;
            }
          });
        });

        if (Object.keys(fieldData).length === 0) {
          fieldData = '';
        }
        ticket_sign_data[ticketId] = fieldData;
      });
      return ticket_sign_data;
    },
  },
}
</script>
<style>
  .register_box{
    width: 650px;
    max-width: 100%;
    margin: auto;
    padding: 20px 0;
  }
  .email_message{
    margin: 20px 0;
  }
  .email_message a{
    color: #55a047;
    font-weight: 700;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid #55a047;
    transition: all .3s;
  }
  .email_message a:hover{
    color: #ffffff;
    background: #55a047
  }
  .sms_message{
    margin: 20px 0;
  }
  .sms_message a{
    color: #8484ee;
    font-weight: 700;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid #8484ee;
    transition: all .3s;
  }
  .sms_message a:hover{
    color: #ffffff;
    background: #8484ee
  }
  .email_no_click{
    pointer-events: none;
    color: #cecece !important;
    border-color: #cecece !important;
  }
  .sms_no_click{
    pointer-events: none;
    color: #cecece !important;
    border-color: #cecece !important;
  }
  .agree_box{
    padding: 12px 0;
    text-align: center;
  }
  .ticket_sign_list{
    margin-top: 40px;
  }
  .ticket_sign_list_title{
    display: inline-block;
    font-weight: bold;
    font-size: 20px;
    line-height: 1.5;
    margin-top: 20px;
    margin-bottom: 7px;
  }
  .residential_area_title{
    display: inline-block;
    font-weight: bold;
    font-size: 20px;
    line-height: 1.5;
    margin-top: 20px;
    margin-bottom: 7px;
  }
  .pop_inputField{
    margin-left: 30px;
    background: peachpuff;
    border-radius: 3px;
    padding: 5px 5px;
  }
  #address{
    width: 20%;
  }
  select{
    padding-left: 8px;
    font-size: 17px;
    width: 40%;
    background: #abd8ff;
    border: 1px solid #c5c5c5;
    border-radius: 5px;
    transition: all .15s ease-in-out;
    box-shadow: inset 0 1px 1px rgba(0,0,0,.075);
  }
</style>